import React from "react";
import Button from "../components/Button/Button";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const benefits = [
  {
    title: "Boost Customer Satisfaction",
    description:
      "Create tailored surveys for your business. Ask key questions to gather essential insights.",
    image:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50cbf7dea165bebe279c3_like%201.png",
  },
  {
    title: "Enhance Operational Efficiency",
    description:
      "With easy feedback collection, your team can focus on what matters most—serving your customers and improving your service.",
    image:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50cbf7dea165bebe279c5_gear.png",
  },
  {
    title: "Grow Your Business",
    description:
      "Gain a deeper understanding of your customers' needs, refine your processes, and build lasting relationships that drive business growth.",
    image:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50cbf7dea165bebe279c7_statistics%201.png",
  },
];

const BenefitsOfZola = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <section className="w-full bg-white py-20" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 text-center">
        {/* Top Text */}
        <motion.p
          initial={{ y: -20, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="text-xs text-[#7f56d9] font-semibold uppercase tracking-widest mb-4"
        >
          Benefits
        </motion.p>

        <motion.h2
          initial={{ y: -20, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }}
          className="text-3xl md:text-5xl font-semibold text-gray-900 mb-6"
        >
          Benefits of Zola
        </motion.h2>

        <motion.p
          initial={{ y: -20, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
          className="text-gray-600 text-lg max-w-2xl mx-auto mb-12"
        >
          Connect your tools, connect your teams. With over 100 apps already available in our directory, your team's favorite tools are just a click away.
        </motion.p>

        {/* Benefits Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ y: 30, opacity: 0 }}
              animate={inView ? { y: 0, opacity: 1 } : {}}
              transition={{
                duration: 0.6,
                delay: 0.3 + index * 0.2,
                ease: "easeOut",
              }}
              className="bg-[#f9fafb] p-8 rounded-2xl flex flex-col items-center text-center hover:shadow-md transition duration-300"
            >
              <img
                src={benefit.image}
                alt={benefit.title}
                className="w-16 h-16 mb-6 object-contain"
              />
              <h3 className="text-xl font-bold text-[#7f56d9] mb-2">
                {benefit.title}
              </h3>
              <p className="text-gray-600 text-base">{benefit.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Buttons */}
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 1, ease: "easeOut" }}
          className="flex flex-col md:flex-row justify-center gap-4"
        >
          <Button variant="primary">Get Started</Button>
          <Button variant="secondary" calendly>Book a demo</Button>
        </motion.div>
      </div>
    </section>
  );
};

export default BenefitsOfZola;
